import tto from "../assets/resim_5.png";

const Tto = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>POLSAN TEKNOKENT Neler Sunuyor?</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>Teknoloji Transfer Ofisi üniversitenin, sanayinin ve bölgesel inovasyon ekosistemindeki paydaşların ihtiyaçları doğrultusunda yeni fikir ve buluşların tespit edilmesi, ticarileşme potansiyellerinin belirlenmesi, fikri mülkiyet haklarıyla ilgili araştırmaların ve başvuruların yapılması, ilgili konularda bilgilendirmelerin yapılması gibi faaliyetleri yürütmektedir. Bu faaliyetlerin yanı sıra aşağıda belirtilen hizmetler de doğrudan ya da ortak olunan üniversitelerin TTO birimleri aracılığı ile verilmektedir;</p>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12">
          <ul>
            <li>İhtiyaçlara yönelik olarak ortak farkındalık, tanıtım, bilgilendirme ve eğitim hizmeti sunabilecektir. </li>
            <li>Uzmanlık alanlarına göre karşılaştırma (benchmarking) yapılabilecek ve örnek uygulamalar yerinde incelenebilecektir. </li>
            <li>Müşterek faaliyetler kapsamında gerçekleştirilecek programlarda ortak olunan üniversitelerin TTO birimleri bünyelerinde bulundurdukları konferans, toplantı vb. alanlarını mutabakata vararak tahsis edebileceklerdir. </li>
            <li>Ortak olunan üniversitelerin TTO birimleri işbirliği sağlanması talebi gelmesi halinde Bölgelerinden gelen taleplere uygun olarak gerekli network desteği ve etkinlik çalışması sağlayacaklardır. </li>
            <li>Ortak proje başvurusunda bulunabileceklerdir. </li>
            <li>Ortak olunan üniversitelerin TTO birimleri, ihtiyaç olması halinde diğer Tarafın onaylaması durumunda uzman havuzundan faydalanabilecektir. </li>
            <li>Protokol süresince Taraflara ait sosyal medya araçlarından iş birliği bünyesinde yapılacak ortak faaliyetlerin duyurusunun yapılması sağlanacaktır. </li>
            <li>Taraflar üniversite sanayi işbirliğine dayalı, proje faaliyetleri, eşleştirme, fikri sınai mülkiyet hakları, teknogirişimcilik ve firma kurma (startup/spinoff) konularda karşılıklı görüş alışverişinde bulunabilecektir. </li>
            <li>Taraflar üniversite sanayi işbirliği ve protokoller kapsamında proje pazarı, eşleştirme etkinliği, sergi, fuar vb. çeşitli etkinlik faaliyetlerini ortak olarak düzenleyebileceklerdir. </li>
            <li>Tekno girişimciliğin geliştirilmesine yönelik karşılıklı olarak kaynaklardan (mentor, eğitmen, akademik eşleştirme vb.), iş bağlantılarından ve Teknokent hizmetlerinden yararlandırma hizmetini verebileceklerdir. </li>
          </ul>
        </div>
        {/* <div className="col-md-6 col-sm-6 mt-4 justify-content-md-center d-flex">
          <img src={tto} alt="TTO" className="img-fluid  w-50 mb-4" />
        </div> */}

      </div>
    </>
  );
};

export default Tto;
